// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/single_work/index.js
// modified with global simulating transforms: post
// MAGIC_DESPROCKET_END
/* eslint-disable
    @typescript-eslint/no-this-alias,
    @typescript-eslint/no-unused-vars,
    prettier/prettier,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// A better way to approach this is by serializing attachment collection and then
// using backbone collection to represent data
import $ from 'jquery';
import Backbone from 'backbone';
import { is_logged_in } from 'js/core_pre_webpack/utils/general_helpers';
const $a = window.$a || {};
$a.is_logged_in = is_logged_in;

class AttachmentPreviewController extends Backbone.View {
  static initClass() {
    this.prototype.events =
      {"click .js-preview-attachment-button[data-preview-attachment-id]": "previewLinkClicked"};
  }

  initialize(opts) {
    if (opts.attachment) {
      this.attachment = opts.attachment;
      this.updateUI();
    }

    if (opts.multiple_viewable_attachments && ($('.js-viewable-attachments-button').length > 0)) {
      const that = this;
      new HoverPopover({
        el: '.js-viewable-attachments-button',
        show_delay: 200,
        hide_delay: 300,
        html: true,
        content: this.getPopoverContent,
        // We are explicitly specifying the template, so no need to sanitize
        sanitize: false,
        on_shown($popover) {
          return that.$popover_el = this.$el;
        }
      });
    }
  }

  previewLinkClicked(e) {
    const attachment_id = this.$(e.currentTarget).data("preview-attachment-id");
    if (this.attachment.id === attachment_id) { return; }
    this.attachment.id = attachment_id;
    this.attachment.index = this.$(e.currentTarget).data("preview-attachment-index");
    return this.updateUI();
  }

  updateUI() {
    // Render and display preview for the newly selected attachment
    window.SingleWork.show_preview(this.attachment.id);

    // Show eye icon next to currently previewed atachment
    this.$('.js-preview-attachment-button[data-preview-attachment-id] .js-active-attachment-preview')
      .removeClass("active-preview");

    this.$(`.js-preview-attachment-button[data-preview-attachment-id='${this.attachment.id}'] \
.js-active-attachment-preview`)
      .addClass("active-preview");

    // Update previewed attachment index number
    return this.$('.js-viewable-attachments-preview-index').text(this.attachment.index + 1);
  }


  getPopoverContent() {
    return this.$('.js-viewable-attachments-popover-content').html();
  }
}

AttachmentPreviewController.initClass();

if (window.SingleWork) {
  window.SingleWork.AttachmentPreviewController = AttachmentPreviewController
}

export default AttachmentPreviewController
// MAGIC_DESPROCKET_START
window.AttachmentPreviewController = AttachmentPreviewController;
// MAGIC_DESPROCKET_END
